/**
 * Meta refuses an app ad set whose OS targeting doesn't match the app's store:
 * "The app you're trying to create an ad for is on a different operating system than targeting
 * settings for this ad set." (live, 2026-09-29 — Traffic → App without it failed every goal).
 */
export function appOsTargeting(storeUrl: string): { user_os: string[]; device_platforms: string[] } | undefined {
  if (!storeUrl) return undefined;
  const ios = /apps\.apple\.com|itunes\.apple\.com/i.test(storeUrl);
  return { user_os: [ios ? 'iOS' : 'Android'], device_platforms: ['mobile'] };
}
